import { mainModules, managementModules, systemModules, type ModuleConfig, VIEW_SUFFIXES } from "@/components/admin/PermissionEditor";

// Build a flat map: tab ID → permission prefixes
const allModules: ModuleConfig[] = [...mainModules, ...managementModules, ...systemModules];

const tabPermissionMap: Record<string, { prefixes: string[]; alwaysAccessible?: boolean }> = {};
for (const mod of allModules) {
  tabPermissionMap[mod.id] = {
    prefixes: mod.permissionPrefixes || [],
    alwaysAccessible: mod.alwaysAccessible,
  };
}

/**
 * Check if an admin has access to a given tab ID based on their permissions.
 * Super admins always have access.
 */
export function hasTabAccess(
  tabId: string,
  isSuperAdmin: boolean,
  permissions: { permission_key: string }[]
): boolean {
  if (isSuperAdmin) return true;

  const config = tabPermissionMap[tabId];
  if (!config) return false;
  if (config.alwaysAccessible) return true;
  // Default-deny: a tab without explicit prefixes is hidden until the
  // module config opts in via `alwaysAccessible: true` or grants matching
  // permission prefixes. Prevents the "optimistic full sidebar" flash on
  // first paint while permissions are still loading.
  if (config.prefixes.length === 0) return false;

  // Check if the admin has ANY permission that starts with one of the module's prefixes
  return permissions.some(p =>
    config.prefixes.some(prefix => p.permission_key.startsWith(prefix)) ||
    p.permission_key === '*'
  );
}

export { tabPermissionMap };
